import { View, ViewStyle, TouchableOpacity } from "react-native";
import { Link } from "expo-router";

interface CardItemProps {
  actionButtons?: React.ReactNode;
  cardContent?: React.ReactNode;
  style?: ViewStyle;
  href?: string;
  onPress?: () => void;
}

export default function CardItem({
  cardContent,
  actionButtons,
  style,
  href,
  onPress,
}: CardItemProps) {
  const content = (
    <View
      className="flex flex-row border border-gray-200 rounded-xl md:p-6 p-3 justify-between gap-x-4"
      style={style}
    >
      <View className={`flex-1 ${actionButtons ? undefined : "w-full"}`}>
        {cardContent}
      </View>
      {actionButtons ? <View>{actionButtons}</View> : null}
    </View>
  );

  if (href) {
    return <Link href={href}>{content}</Link>;
  }

  if (onPress) {
    return (
      <TouchableOpacity onPress={onPress} activeOpacity={0.7}>
        {content}
      </TouchableOpacity>
    );
  }

  return content;
}
